import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-verify-page',
    templateUrl: './verify-page.component.html',
    styleUrls: ['./verify-page.component.scss'],
    standalone: false
})
export class VerifyPageComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  toLoginPage() {
    this.router.navigateByUrl("/login");
  }

}
